module.exports = __webpack_public_path__ + "img/p_24.51c73578.png";